import { AxiosInstance } from 'axios';
import addMsalTokenInterceptor from './interceptors/addMsalTokenInterceptor';
import setAcceptLanguageHeader from './interceptors/setAcceptLanguageHeader';
import transformDateToSendToServer from './interceptors/transformDateToSendToServer';
import throwIfAccessIsForbiddenAcceptatieAPP from './interceptors/throwIfAccessIsForbiddenAcceptatieAPP';
import transformDateStringToDateInterceptor from './interceptors/transformDateStringToDateInterceptor';
const addInterceptors = (instance: AxiosInstance) => {
    transformDateStringToDateInterceptor(instance);
    setAcceptLanguageHeader(instance);
    addMsalTokenInterceptor(instance);
    transformDateToSendToServer(instance);
    throwIfAccessIsForbiddenAcceptatieAPP(instance);
};

export default addInterceptors;
